"use client";
import styles from './index.module.scss';
import IconButton from "@/app/_components/Shared/IconButton";
import {useRouter} from "nextjs-toploader/app";
import TextTitle from "@/app/_components/Shared/TextTitle";
import Services from "@/app/_components/Shared/Services";
import Image from "next/image";
import {servicesData} from "./data";
import HowBankingImage from "@/app/images/how-banking.png";

export default function Banking() {
    const router = useRouter();

    const onClick = () => {
        router.push('/banking-request');
    }

    return (
        <div className={"container-wrapper " + styles.wrapper}>
            <div className={styles.container}>
                <div className={"container-wrapper"}>
                    <div className={styles.content}>
                        <h1>Your Gateway to Secure and Fast Banking Solutions</h1>
                        <p>
                            Setting up a bank account in the UAE can seem overwhelming, but with Ninjaz, it doesn’t
                            have to be. <br></br>
                            We connect you with top UAE banks, ensure compliance, and handle the
                            paperwork seamlessly.
                        </p>
                        <div className={styles.buttons}>
                            <IconButton onClick={onClick}>
                                Start Now
                            </IconButton>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.serviceContainer}>
                <div className="container-wrapper">
                    <TextTitle className={styles.title}>
                        Why Choose Ninjaz?
                    </TextTitle>
                    <Services data={servicesData}/>
                </div>
            </div>
            <div className={styles.serviceContainer}>
                <div className="container-wrapper">
                    <p className={styles.banner}>
                        Avoid delays and unlock business growth with Ninjaz. <strong>Book Your Personalized
                        Consultation</strong>—transparent, professional, and worth the investment!
                    </p>
                    <div className={styles.bannerButtons}>
                        <IconButton onClick={onClick}>
                            Book Consultation
                        </IconButton>
                    </div>
                </div>
            </div>
            <div className={styles.serviceContainer}>
                <div className="container-wrapper">
                    <p className={styles.textTitle}>
                        Ready to Open a Bank Account in the UAE?
                    </p>
                    <p className={styles.text}>
                        Opening a bank account in the UAE doesn’t have to be complicated. Ninjaz makes it
                        simple by connecting you with top banks, handling all compliance, and managing the
                        paperwork for you.
                    </p>
                    <Image className={styles.howImage} src={HowBankingImage} alt="How Banking"/>
                    <p className={styles.text}>
                        <i>Note: Your physical presence may be required to sign documents. Processing times may vary.</i>
                    </p>
                </div>
            </div>
        </div>
    );
}
